import { Anchor, Button, Grid, Image, Stack, Text, Title } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import {
  img123Final2,
  imgBarCodeFinal2,
  imgDinLabelLaptop,
  imgDinLabelLogoLetras,
  imgImagesFinal,
  imgMailIcon,
  imgQrCodeNuevo,
  imgTutoriales,
  imgTxtPng,
  imgVariableDataFinal2,
} from "../shared/images";
import { NavBarContainer } from "./NavBarContainer";

export function MarketingHome() {
  const { t } = useTranslation();

  const features = [
    { title: t("marketing.featureNumbers"), img: img123Final2 },
    { title: t("marketing.featureImages"), img: imgImagesFinal },
    { title: t("marketing.featureVariable"), img: imgVariableDataFinal2 },
    { title: t("marketing.featureQr"), img: imgQrCodeNuevo },
    { title: t("marketing.featureText"), img: imgTxtPng },
    { title: t("marketing.featureBarcode"), img: imgBarCodeFinal2 },
  ];

  return (
    <NavBarContainer variant="marketing">
      <Stack gap="xl" py="lg">
        <Stack align="center" gap="md">
          <Image src={imgDinLabelLogoLetras} alt="DinLabel" maw={360} />
          <Title order={1} ta="center">
            {t("marketing.headline")}
          </Title>
          <Text ta="center" maw={560}>
            {t("marketing.slogan")}
          </Text>
          <Button component={Link} to="/install" size="md">
            {t("nav.download")}
          </Button>
        </Stack>

        <Grid>
          {features.map((f) => (
            <Grid.Col key={f.title} span={{ base: 12, sm: 6, md: 4 }}>
              <Stack align="center" gap="xs">
                <Title order={3} ta="center">
                  {f.title}
                </Title>
                <Image src={f.img} alt={f.title} maw={180} />
              </Stack>
            </Grid.Col>
          ))}
        </Grid>

        <Grid align="center">
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Image
              src={imgDinLabelLogoLetras}
              alt="DinLabel"
              maw={280}
              mx="auto"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Title order={2}>{t("marketing.whyTitle")}</Title>
            <Text mt="sm">{t("marketing.whyBody")}</Text>
          </Grid.Col>
        </Grid>

        <Grid align="center">
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Stack align="center">
              <Text ta="center" fw={600}>
                {t("marketing.tryTitle")}
              </Text>
              <Button component={Link} to="/install">
                {t("nav.download")}
              </Button>
            </Stack>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Image src={imgDinLabelLaptop} alt="" maw={320} mx="auto" />
          </Grid.Col>
        </Grid>

        <Stack align="center" gap="md">
          <Title order={2}>{t("marketing.needHelp")}</Title>
          <Grid w="100%">
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <Stack align="center">
                <Image src={imgMailIcon} alt="" w={64} />
                <Anchor href="mailto:support@dinlabel.com" fw={600}>
                  {t("marketing.customerService")}
                </Anchor>
                <Text ta="center" size="sm">
                  {t("marketing.customerServiceText")}
                </Text>
              </Stack>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <Stack align="center">
                <Image src={imgTutoriales} alt="" w={64} />
                <Anchor component={Link} to="/tutorials" fw={600}>
                  {t("nav.tutorials")}
                </Anchor>
                <Text ta="center" size="sm">
                  {t("marketing.tutorialsText")}
                </Text>
              </Stack>
            </Grid.Col>
          </Grid>
        </Stack>

        <Text ta="center" size="sm" c="dimmed">
          <Anchor component={Link} to="/privacy">
            {t("marketing.privacyFooter")}
          </Anchor>
        </Text>
      </Stack>
    </NavBarContainer>
  );
}
